import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Comment fonctionne la commission de 25 % ?",
    a: "Lors des années 2, 3 et 4, vous percevez 25 % de remise revendeur sur chaque renouvellement de licence de vos clients. Cette commission est automatique : vous n'avez aucune action à effectuer.",
  },
  {
    q: "Dois-je gérer les renouvellements moi-même ?",
    a: "Non. Norton gère l'ensemble du cycle de renouvellement : facturation client, renouvellement des licences et continuité de service. Vous n'avez rien à faire après la vente initiale.",
  },
  {
    q: "Pendant combien de temps suis-je rémunéré ?",
    a: "Le modèle s'étale sur 4 ans : l'année 1 correspond à la vente initiale, et les années 2, 3 et 4 vous génèrent un revenu passif récurrent via les renouvellements.",
  },
  {
    q: "À qui s'adresse le programme Norton Empower ?",
    a: "Le programme est idéal pour les prestataires IT et les revendeurs qui souhaitent transformer chaque client en source de revenus passifs, en s'appuyant sur la puissance de la marque Norton.",
  },
  {
    q: "Y a-t-il un travail supplémentaire après la première vente ?",
    a: "Aucun. C'est tout l'intérêt du modèle : une vente unique génère plusieurs années de revenus, sans gestion ni relance de votre part. Le système est 100 % automatisé côté renouvellement.",
  },
  {
    q: "Pourquoi choisir Norton plutôt qu'une autre solution ?",
    a: "Norton est une marque mondiale reconnue dans la cybersécurité, avec une demande forte et constante en protection informatique. Cette notoriété facilite vos ventes et sécurise vos revenus récurrents.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="relative py-28 lg:py-36 px-6 md:px-12" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-norton-yellow">
            Questions fréquentes
          </span>
          <h2 className="text-3xl sm:text-5xl font-heading font-semibold tracking-tight mt-4">
            Tout ce qu'il faut savoir
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-zinc-800"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger className="text-left text-base sm:text-lg font-heading font-medium text-zinc-200 hover:no-underline hover:text-norton-yellow py-6 [&[data-state=open]]:text-norton-yellow">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-zinc-400 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
